import React from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useOrders } from "../hooks";
import { orderStatusLabel } from "../../../helpers/enum-labels";

interface IProps {
  customerId: number;
}

export const OrdersList: React.FC<IProps> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, loading } = useOrders({ where: { customerId } });

  if (loading) return <Loading />;

  if (!data?.orders?.results?.length) {
    return <EmptyList text="Aucune commande" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Numéro</TableCell>
          <TableCell header>Statut</TableCell>
          <TableCell header align="right">
            Total TTC
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.orders?.results?.map((order) => (
          <TableRow
            key={`order-${order.id}`}
            onClick={() => navigate(`/order/${order.id}`)}
          >
            <TableCell>{order.number ?? `#${order.id}`}</TableCell>
            <TableCell>{orderStatusLabel(order.status)}</TableCell>
            <TableCell align="right">
              {((order.totalTtcCents ?? 0) / 100).toFixed(2)} €
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
